import React, { useState } from "react";
import { Link } from "react-router-dom";
import AppLink from "./link";
import { NavProps } from "../types/appTypes";
import LanguageSwitcher from "./languageSwitcher";
import { navData } from "../utils/data/navData";
import { useTranslation } from "react-i18next";

const AppNav: React.FC<NavProps> = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen((s) => !s);

  return (
    <>
      {/* Desktop nav */}
      <nav className="hidden lg:block">
        <div className="swiss-grid" style={{ rowGap: 0 }}>
          <div className="col-span-12 flex items-center justify-between h-16">
            <Link
              to="/"
              className="text-[1.125rem] font-bold tracking-tight text-ink hover:text-accent"
            >
              KODE
            </Link>

            <ul className="flex items-center gap-1">
              {navData.map((navItem, index) => (
                <li key={index}>
                  <AppLink path={navItem.path} text={t(navItem.text)} />
                </li>
              ))}
            </ul>

            <div className="flex items-center gap-4">
              <LanguageSwitcher />
              <Link to="/contact" className="btn btn-primary !min-h-[40px] !px-4 !text-[0.875rem]">
                {t("kode.nav.contact")}
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile nav */}
      <nav className="lg:hidden">
        <div className="swiss-grid" style={{ rowGap: 0 }}>
          <div className="col-span-12 flex items-center justify-between h-14">
            <Link to="/" className="text-[1rem] font-bold tracking-tight text-ink">
              KODE
            </Link>
            <button
              onClick={toggleMenu}
              aria-label={t("Menu")}
              className="inline-flex flex-col items-center justify-center gap-[5px] w-10 h-10 border border-ink"
            >
              <span className="block w-5 h-px bg-ink" />
              <span className="block w-5 h-px bg-ink" />
              <span className="block w-5 h-px bg-ink" />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile sheet */}
      <div
        className={`fixed inset-0 z-50 bg-paper transition-opacity lg:hidden ${
          isOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div className="swiss-grid h-16" style={{ rowGap: 0 }}>
          <div className="col-span-12 flex items-center justify-between h-16">
            <Link to="/" onClick={toggleMenu} className="text-[1rem] font-bold tracking-tight text-ink">
              KODE
            </Link>
            <button
              onClick={toggleMenu}
              aria-label="Close menu"
              className="relative w-10 h-10 border border-ink"
            >
              <span className="absolute left-1/2 top-1/2 block w-5 h-px bg-ink -translate-x-1/2 rotate-45" />
              <span className="absolute left-1/2 top-1/2 block w-5 h-px bg-ink -translate-x-1/2 -rotate-45" />
            </button>
          </div>
        </div>

        <div className="swiss-grid pt-7">
          <div className="col-span-12">
            <span className="swiss-caption">{t("Menu")}</span>
            <ul className="mt-5 flex flex-col">
              {navData.map((navItem, index) => (
                <li key={index} className="border-t border-ink-14" onClick={toggleMenu}>
                  <Link
                    to={navItem.path}
                    className="block py-4 text-[2rem] font-medium tracking-tight text-ink hover:text-accent"
                  >
                    {t(navItem.text)}
                  </Link>
                </li>
              ))}
              <li className="border-t border-ink-14" />
            </ul>

            <div className="mt-7 flex flex-col gap-4">
              <LanguageSwitcher />
              <Link to="/contact" onClick={toggleMenu} className="btn btn-primary w-full">
                {t("kode.nav.contact")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppNav;
